import axios, { AxiosPromise } from 'axios';

const pristupPlatnost = (token: string): AxiosPromise => {
    return axios({
        method: 'GET',
        url: 'Akcionar/Pristup/Platnost',
        params: {
            initcode: token
        }
    });
};

export default pristupPlatnost;
